import {call, put, takeEvery} from "redux-saga/effects"
import {
    CREATE_RATES_REQUEST,
    GET_RATES_REQUEST,
    GET_RATES_REQUEST_SUCCESS
} from "./actionTypes"

function* getRatesSaga({payload}) {
    try {
        const callBack = yield call(getRatesSagaAsync, payload)
        if (callBack.success) {
            yield put({type: GET_RATES_REQUEST_SUCCESS, callBack})
        } else {

        }
    } catch (err) {
        console.error(err);
    }
}


const getRatesSagaAsync = async () => {
    const response = await fetch(`${process.env.REACT_APP_SERVER_URL}/api2/rate/get`, {
        method: "GET",
        headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
        }
    })
    return await response.json()
}

function* createRatesSaga({payload}) {
    try {
        const callBack = yield call(createRatesSagaAsync, payload)
        if (callBack.success) {
            yield put({type: GET_RATES_REQUEST_SUCCESS, callBack})
        } else {

        }
    } catch (err) {
        console.error(err);
    }
}


const createRatesSagaAsync = async () => {
    const response = await fetch(`${process.env.REACT_APP_SERVER_URL}/api2/rate/create`, {
        method: "GET",
        headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
        }
    })
    return await response.json()
}


function* newsSaga() {
    yield takeEvery(GET_RATES_REQUEST, getRatesSaga)
    yield takeEvery(CREATE_RATES_REQUEST, createRatesSaga)
}

export default newsSaga
